import { HeaderChangeAction, ChangeLoadingStatusAction } from './../../core/store/general/actions';
import { DashboardService } from './../../core/services/dashboard.service';
import { SharedContainer } from './../../shared/shared.container';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppState } from '../../shared/app-state.container';


@Injectable()
export class DashboardContainer {

    lastBookings = [];
    activeBookings = [];
    pastBookings = [];
    cancelledBookings = [];

    lastRequests = [];
    allRequests = [];

    user = null;

    constructor(
        protected sharedContainer: AppState,
        private dashboardService: DashboardService,
    ) {
        this.changeHeader();
        this.retrieveLastBookedByUser(2);
        this.getLastRequestsByUser(2);
    }

    changeHeader() {
        this.sharedContainer.generalState$.dispatch(new HeaderChangeAction(1, { headerType: 'dashheader' }));
    }

    getNightsDifference(from, to) {
        const date1 = new Date(from);
        const date2 = new Date(to);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    formatDate(date) {
        const monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];
        const dayNames = [
            'Sunday', 'Monday', 'Tuesday',
            'Thursday', 'Wednesday', 'Friday', 'Saturday'];

        const day = date.getDate();
        const weekDay = date.getDay();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        return { day: dayNames[weekDay], month: monthNames[monthIndex], year: year, number: day };
    }

    isDateBeforeToday(date) {
        return new Date(date.toDateString()) < new Date(new Date().toDateString());
    }

    createBookingItem(bookingItem, status) {
        console.log(bookingItem);
        const nights = this.getNightsDifference(bookingItem.fromDate, bookingItem.toDate);
        return {
            hotelName: bookingItem.hotelName,
            address: bookingItem.hotelAddress1 + ',' + bookingItem.hotelCity + ',' + bookingItem.hotelCountry,
            price: nights * bookingItem.dailyCharge + bookingItem.mealsCharge + bookingItem.extrasCharge,
            checkin: this.formatDate(new Date(bookingItem.fromDate)),
            checkout: this.formatDate(new Date(bookingItem.toDate)),
            numberOfNights: nights,
            status: status,
            image: '${environment.backendRoot}/webresources/frontend/entity.hotelpics/image/thumbnail/' + bookingItem.hotelPic,
            serviceDataId: bookingItem.serviceDataId,
            id: bookingItem.id
        };
    }

    removeBooking(bookingid) {
        this.dashboardService.removeBooking(bookingid).subscribe(data => {
            console.log(data);
        });
    }

    retrieveLastBookedByUser(amount) {
        this.dashboardService.getLastBookedByUser(this.getUserId(), amount).subscribe(offers => {
            offers.forEach(offer => {
                const offerToDate = new Date(offer.fromDate);
                if (this.isDateBeforeToday(offerToDate)) {
                    this.lastBookings.push(this.createBookingItem(offer, 'Past'));
                } else {
                    this.lastBookings.push(this.createBookingItem(offer, 'active'));
                }
            });
        });
    }

    getTimeRemaining(date) {
        let seconds = (date.getTime() - new Date().getTime()) / 1000;

        const days = Math.floor(seconds / (3600 * 24));
        seconds -= days * 3600 * 24;
        const hrs = Math.floor(seconds / 3600);
        seconds -= hrs * 3600;
        const mnts = Math.floor(seconds / 60);
        seconds -= mnts * 60;
        return { days, hours: hrs, minutes: mnts };
    }

    createRequestItem(singleRequest) {
        const nights = this.getNightsDifference(singleRequest.fromDate, singleRequest.toDate);
        return {
            destination: singleRequest.destination,
            requestNumber: singleRequest.id,
            personInfo: { rooms: singleRequest.noOfRooms, adults: singleRequest.noOfAdults, children: singleRequest.noOfChildren },
            totalOffers: singleRequest.offerCount,
            checkin: this.formatDate(new Date(singleRequest.fromDate)),
            checkout: this.formatDate(new Date(singleRequest.toDate)),
            numberOfNights: nights,
            expiring: this.getTimeRemaining(new Date(singleRequest.offersStartExpiring)),
            exclusiveCategories: singleRequest.extras ? singleRequest.extras.split(',') : [],
            personalRequest: singleRequest.personalRequest,
            id: singleRequest.id,
            fromDate: new Date(singleRequest.fromDate),
            toDate: new Date(singleRequest.toDate),
            accommodationtype: singleRequest.accommodationType,
            dailybudget: singleRequest.priceRange
        };
    }

    getLastRequestsByUser(amount) {
        this.lastRequests = new Array();
        this.dashboardService.getLastRequestsByUser(this.getUserId(), amount).subscribe(requests => {
            requests.forEach(singleRequest => {
                this.lastRequests.push(this.createRequestItem(singleRequest));
            });
        });
    }

    async getAllActiveRequestsByUser() {
        this.allRequests = new Array();
        // this.enableSpinner(true);
        await this.dashboardService.getAllActiveRequestsByUser(this.getUserId()).subscribe(requests => {
            requests.forEach(singleRequest => {
                this.allRequests.push(this.createRequestItem(singleRequest));
            });
            // this.enableSpinner(false);
        });
    }

    getAllBookings() {
        this.getAllActiveBookingsByUser();
        this.getAllPastBookingsByUser();
        this.getAllCancelledBookingsByUser();
    }

    getAllActiveBookingsByUser() {
        this.activeBookings = new Array();
        // this.enableSpinner(true);
        this.dashboardService.getAllActiveBookingsByUser(this.getUserId()).subscribe(requests => {
            requests.forEach(singleBooking => {
                this.activeBookings.push(this.createBookingItem(singleBooking, 'active'));
            });
            // this.enableSpinner(false);
        });
    }

    getAllPastBookingsByUser() {
        this.pastBookings = new Array();
        this.dashboardService.getAllPastBookingsByUser(this.getUserId()).subscribe(requests => {
            requests.forEach(singleBooking => {
                this.pastBookings.push(this.createBookingItem(singleBooking, 'past'));
            });
        });
    }

    getAllCancelledBookingsByUser() {
        this.cancelledBookings = new Array();
        this.dashboardService.getAllCancelledBookingsByUser(this.getUserId()).subscribe(requests => {
            requests.forEach(singleBooking => {
                this.cancelledBookings.push(this.createBookingItem(singleBooking, 'cancelled'));
            });
        });
    }

    getUserInfo() {
        return this.dashboardService.getUser(this.getUserId());
    }

    getUserId() {
        const user = localStorage.getItem('user');
        return JSON.parse(user).id;
    }

    changeUserInformation(userInfo) {
        // this.enableSpinner(true);
        this.dashboardService.changeUserInformation(this.getUserId(), userInfo)
            .subscribe(data => {
                // this.enableSpinner(false);
                // window.location.reload();
            });
    }

    saveCreditCardDetails(data, serviceDataId) {
        // data.user = this.getUserId();
        this.dashboardService.changeCreditCardInfo(serviceDataId, data)
            .subscribe(res => alert('Payment details were changed successsfully!'));
    }

    getProfileImage() {
        if (this.user === null) {
            this.getUserInfo().subscribe(user => {
                this.user = user;
                return 'data:image/jpeg;base64,' + this.user.photo;
            });
        } else {
            return 'data:image/jpeg;base64,' + this.user.photo;
        }
    }

    getUsersMessages(): Observable<any> {
        return this.dashboardService.getUsersMessages(this.getUserId());
    }

    sendMessage(message): Observable<any> {
        message.customerId = this.getUserId();
        return this.dashboardService.sendMessage(message.threadId, message);
    }

    deleteMessageThread(threadId): Observable<any> {
        return this.dashboardService.deleteThread(threadId);
    }

    getBookingFees(bookingId): Observable<any> {
        return this.dashboardService.getBookingFees(bookingId);
    }

    cancelBooking(bookingId, cancellationFeeId, index) {
        this.dashboardService.cancelBooking(bookingId, cancellationFeeId).subscribe(reply => {
            this.activeBookings[index].status = 'cancelled';
            this.cancelledBookings.push(this.activeBookings[index]);
            this.activeBookings.splice(index, 1);
        });
    }

    enableSpinner(enabled) {
        this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: enabled }));
    }

    removeRequest(index) {
        this.dashboardService.removeRequest(this.allRequests[index].id)
            .subscribe(reply => this.allRequests.splice(index, 1));
    }

    sendUserEmailConfirm(userId) {
        this.dashboardService.sendUserEmailConfirm(userId).subscribe(reply => {
            if (reply) {
                return true;
            }
        });
    }
}


